import { forEach } from 'lodash';
import { getAccountDetails } from '../../businessLogic/AccountsBL';
import { ROLE_ENDORSER, YOUTH_ACCOUNT_PRODUCT_CODES } from '../../constants/StringConstants';

let isSweepEnabled = undefined;
let isSweepTransferOut = false;
let isSweep = false;

export const accessToken = (state) => state.config.getIn(['configInfo']).accessToken;
export const apiBaseUrlPAAS = (state) => state.config.getIn(['configInfo']).apiBaseUrlPAAS || '';
export const clientContext = (state) => state.config.getIn(['configInfo']).clientContext;
export const sourceType = (state) => state.config.get('sourceType');

export const bankId = (state) => {
  return state.config.getIn(['configInfo']).bankId === 'DYB'
    ? 'CB'
    : state.config.getIn(['configInfo']).bankId;
};

export const getBrandId = (config) => {
  return config.getIn(['configInfo']).brandId;
};
export const staffBranchSortCode = (state) => {
  return state.config.getIn(['configInfo']).staffBranchSortCode;
};
export const customerNumber = (state) => {
  return state.config.getIn(['configInfo']).customerNumber;
};
export const isLoading = (loader) => loader.get('isLoader');

export const isSweepEnable = (accountList, config) => {
  if (isSweepEnabled !== undefined) {
    return isSweepEnabled;
  }
  forEach(accountList.get('accountList').accounts, (account) => {
    if (account.actions_available['/account/sweeps']) isSweep = true;
    if (account.actions_available['/account/sweeps/transfer/out']) isSweepTransferOut = true;
  });
  isSweepEnabled =
    isSweepTransferOut && isSweep && (getBrandId(config) === 'B' || getBrandId(config) === 'VM');
  return isSweepEnabled;
};
export const isTransactionAlertEnable = (state) => {
  const isTransactionAlertEnabled = state.config.getIn(['configInfo']).showTransactionAlert;
  const accountId = state.accountList.get('selectedAccountId');
  const accountDetails = getAccountDetails(
    accountId,
    state.accountList.get('accountList').accounts
  );
  return (
    accountDetails.actions_available['/account/alerts/transaction/debit'] &&
    isTransactionAlertEnabled
  );
};
export const isSweepAccountEnable = (accountId, accountList, config) => {
  const selectedAccountDetails = getAccountDetails(accountId, accountList);
  return (
    selectedAccountDetails.actions_available['/account/sweeps'] &&
    (getBrandId(config) === 'B' || getBrandId(config) === 'VM')
  );
};
export const getSavingsAccountsID = (accountList) => accountList.get('savingAccountID');

export const isCAUser = (userDetails) => {
  return (
    userDetails.get('userDetails').segment === 'B' &&
    userDetails.get('userDetails').sub_segment === 'CA'
  );
};
export const isSMEAlertEnable = (state) => {
  const isSMEAlertFlagEnabled = state.config.getIn(['configInfo']).showSMEAlert;
  const accountId = state.accountList.get('selectedAccountId');
  const accountDetails = getAccountDetails(
    accountId,
    state.accountList.get('accountList').accounts
  );
  return (
    accountDetails.actions_available['/account/alerts/transaction/credit'] &&
    isCAUser(state.userDetails) &&
    isSMEAlertFlagEnabled
  );
};

export const isBalanceAlertEnabled = (accountId, accountList) => {
  const {
    product: { code: productCode } = {},
    actions_available: actions,
    role,
  } = getAccountDetails(accountId, accountList);

  if (role === ROLE_ENDORSER && YOUTH_ACCOUNT_PRODUCT_CODES.includes(productCode)) {
    return actions['/account/alerts/balance'];
  }

  /**
   * DP
   *
   * I feel that this should always point to `/account/alerts/balance`.
   * Unfortunately global fix might cause more issues in the
   * Capability Matrix, so redtape solution for Youth Account products.
   */
  return actions['/account/alerts'];
};
